import { twMerge } from "tailwind-merge";
import PropTypes from "prop-types";
import React from "react";

export default function LinkButton({ disabled, className, onClick, ...props }) {
  let twStyles = "text-semibold m-0 p-0";

  if (disabled) twStyles += " pointer-events-none opacity-60";

  const c = twMerge(twStyles, className);

  return (
    <button {...props} className={c} onClick={onClick} disabled={disabled} />
  );
}

LinkButton.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.any,
  onClick: PropTypes.func,
};
